// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F9sgF","right":"styles_right__1HMuE"};